import script from "./Avanzata.vue?vue&type=script&setup=true&lang=js"
export * from "./Avanzata.vue?vue&type=script&setup=true&lang=js"

import "./Avanzata.vue?vue&type=style&index=0&id=06812177&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06812177"]])

export default __exports__